import { EuiSpacer } from '@elastic/eui';
import LangTable from 'components/Web_User_Interface/720p_Series/Software/Language/langTable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  LangTable,
  BreadCrumbs,
  SEOHelmet,
  React
};